import { ThrowLiteError } from '../lite-error.js';
import { F32 } from '../engine/typed-arrays.js';
import { resolveAccessor } from './gltf-parser.js';
import { mat4ComposeInto } from '../math/mat4-compose-into.js';
import { setThinInstances } from '../mesh/thin-instance.js';
import { enableThinInstanceWorldBounds } from '../mesh/enable-thin-instance-world-bounds.js';

function collectMeshesUnderNode(tn) {
  const out = [];
  for (const c of tn?.children ?? []) {
    if (c && typeof c === "object" && "material" in c) {
      out.push(c);
    }
  }
  return out;
}
function buildInstanceMatrices(translation, rotation, scale, count) {
  const matrices = new F32(count * 16);
  for (let i = 0; i < count; i++) {
    const tx = translation ? translation[i * 3] : 0;
    const ty = translation ? translation[i * 3 + 1] : 0;
    const tz = translation ? translation[i * 3 + 2] : 0;
    const qx = rotation ? rotation[i * 4] : 0;
    const qy = rotation ? rotation[i * 4 + 1] : 0;
    const qz = rotation ? rotation[i * 4 + 2] : 0;
    const qw = rotation ? rotation[i * 4 + 3] : 1;
    const sx = scale ? scale[i * 3] : 1;
    const sy = scale ? scale[i * 3 + 1] : 1;
    const sz = scale ? scale[i * 3 + 2] : 1;
    mat4ComposeInto(matrices, i * 16, tx, ty, tz, qx, qy, qz, qw, sx, sy, sz);
  }
  return matrices;
}
const ext = {
  id: "EXT_mesh_gpu_instancing",
  async applyAsset(_meshes, _root, ctx) {
    const { _json: json, _binChunk: binChunk, _nodeMap: nodeMap } = ctx;
    if (!nodeMap) {
      return {};
    }
    const nodes = json.nodes ?? [];
    for (let nodeIdx = 0; nodeIdx < nodes.length; nodeIdx++) {
      const attrs = nodes[nodeIdx]?.extensions?.EXT_mesh_gpu_instancing?.attributes;
      if (!attrs) {
        continue;
      }
      const tn = nodeMap[nodeIdx];
      if (!tn) {
        continue;
      }
      const meshesForNode = collectMeshesUnderNode(tn);
      if (meshesForNode.length === 0) {
        continue;
      }
      const tAcc = attrs.TRANSLATION !== void 0 ? resolveAccessor(json, binChunk, attrs.TRANSLATION) : null;
      const rAcc = attrs.ROTATION !== void 0 ? resolveAccessor(json, binChunk, attrs.ROTATION) : null;
      const sAcc = attrs.SCALE !== void 0 ? resolveAccessor(json, binChunk, attrs.SCALE) : null;
      let count = 0;
      for (const acc of [tAcc, rAcc, sAcc]) {
        if (!acc) {
          continue;
        }
        if (count === 0) {
          count = acc._count;
        } else if (acc._count !== count) {
          ThrowLiteError(125, nodeIdx);
        }
      }
      if (count === 0) {
        continue;
      }
      const matrices = buildInstanceMatrices(
        tAcc ? tAcc._data : null,
        rAcc ? rAcc._data : null,
        sAcc ? sAcc._data : null,
        count
      );
      for (const mesh of meshesForNode) {
        setThinInstances(mesh, matrices, count);
        enableThinInstanceWorldBounds(mesh);
      }
    }
    return {};
  }
};

export { ext as default };
//# sourceMappingURL=gltf-feature-gpu-instancing.js.map
